import {defineStore} from 'pinia'
import {ref} from 'vue'

export const useBannerStore = defineStore('BannerStore', () => {
    const expiry = ref(0)
    const ttl = 1000 * 60 * 60 * 24; // 24 hours

    function hide() {
        let now = new Date()

        expiry.value = now.getTime() + ttl
    }

    function show() {
        let now = new Date()

        if (expiry.value === 0) {
            return true
        }

        if (now.getTime() > expiry.value) {
            expiry.value = 0;

            return true
        }

        return false
    }

    return {
        expiry,
        hide,
        show
    }
}, {
    persist: true
})

